export default __webpack_public_path__ + "static/media/Social Links.c048f3fc.svg";